import { Link } from 'react-router-dom';
import type { TimelineItem } from '@/types/content';

const Timeline = ({ items }: { items: TimelineItem[] }) => (
  <section aria-labelledby="timeline-title" className="bg-background-100 border border-background-200 rounded-lg p-5">
    <h2
      id="timeline-title"
      className="font-heading text-base font-bold text-foreground-950 flex items-center gap-2 mb-4"
    >
      <i className="ri-timeline-view text-primary-600" />
      第一现场时间线
    </h2>
    <ol className="relative border-l border-primary-200 pl-5 space-y-4">
      {items.map((item, index) => (
        <li key={`${item.time}-${index}`} className="relative">
          <span
            className={`absolute -left-[26px] top-1 w-3 h-3 rounded-full border-2 border-background-100 ${
              index === items.length - 1 ? 'bg-accent-500' : 'bg-primary-500'
            }`}
          />
          <p className="text-[11px] text-foreground-500 flex items-center gap-1">
            <i className="ri-time-line" />
            {item.time}
          </p>
          <p className="mt-1 text-sm leading-6 text-foreground-800">{item.text}</p>
        </li>
      ))}
    </ol>
  </section>
);

export default Timeline;